'use client';

import * as PopoverPrimitive from '@radix-ui/react-popover';
import clsx from 'clsx';
import { forwardRef } from 'react';

import BasicClose from '../../icons/basic/Close';

const PopoverRoot = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverPortal = PopoverPrimitive.PopoverPortal;

const PopoverClose = function() {
  return (
    <PopoverPrimitive.Close
      aria-label="sluiten"
      className="-mr-2 -mt-2 flex aspect-square size-10 min-w-10 items-center justify-center p-2"
    >
      <BasicClose className="size-6" />
    </PopoverPrimitive.Close>
  );
};

const PopoverContent = forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & { noMaxHeight?: boolean }
>(({
  className,
  align = 'center',
  sideOffset = 4,
  noMaxHeight = false,
  ...props
}, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      className={clsx(
        'popover-content text-text-primary z-50 rounded-sm border bg-surface-default shadow-small outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className,
        {
          '!max-h-[none]': noMaxHeight,
        },
      )}
      align={align}
      sideOffset={sideOffset}
      {...props}
    />
  </PopoverPrimitive.Portal>
));

PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export {
  PopoverClose,
  PopoverContent,
  PopoverPortal,
  PopoverRoot,
  PopoverTrigger,
};
